import React from 'react';
import { motion } from 'framer-motion';

/**
 * LoadingSpinner Component
 * 
 * Displays a loading animation that can be used throughout the application.
 * 
 * @param {string} size - Size of the spinner (sm, md, lg)
 * @param {string} color - Color of the spinner (blue, green, teal, etc.)
 * @param {string} className - Additional CSS classes to apply
 */
const LoadingSpinner = ({ 
  size = 'md', 
  color = 'blue',
  className = '' 
}) => {
  // Size mapping
  const sizeMap = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };
  
  // Color mapping
  const colorMap = {
    blue: 'border-blue-500',
    green: 'border-green-500',
    teal: 'border-teal-500',
    purple: 'border-purple-500',
    orange: 'border-orange-500'
  };
  
  const sizeClass = sizeMap[size] || sizeMap.md;
  const colorClass = colorMap[color] || colorMap.blue;
  
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <motion.div 
        className={`${sizeClass} border-4 ${colorClass} border-t-transparent rounded-full`}
        animate={{ rotate: 360 }}
        transition={{ 
          duration: 1,
          repeat: Infinity,
          ease: "linear"
        }}
      />
    </div>
  );
};

export default LoadingSpinner;